import React from 'react';
import NetWorthCard from './NetWorthCard';
import StockHoldings from './StockHoldings';
import CryptoHoldings from './CryptoHoldings';
import './Dashboard.css';

function Dashboard({ summary }) {
  return (
    <div className="dashboard">
      <NetWorthCard accountBreakdown={summary.accountBreakdown} />

      <div className="holdings-grid">
        <StockHoldings />
        <CryptoHoldings />
      </div>
    </div>
  );
}

export default Dashboard;




